var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"apply-page"}},[_c('ApplyHero'),_c('ApplySteps'),_c('Newsletter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }